import { CheckCircle } from "lucide-react";
import React, { useMemo, useState } from "react";
import logoimg from "../../../assets/images/front/user01.webp";
import bannerimg from "../../../assets/image/headerBgJob.jpg";
import Button from "../../form/Button";
import Dropdown from "../../form/Dropdown";
import Tabs from "../../elements/Tabs";
import { useTabQuery } from "../../../hooks/useTabQuery";
import NotFoundPage from "../../common/NotFoundPage";
import CompanyHomeTab from "./CompanyHomeTab";
import CompanyAboutTab from "./CompanyAboutTab";
import CompanyJobsTab from "./CompanyJobsTab";
import Indentification from "../../elements/Indentification";
import { useSelector } from "react-redux";
import { CreateChat } from "../../../services/communicationService";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import StartChatModal from "./StartChatModal";
import CompanyPeopleTab from "./CompanyPeopleTab";
import CompanyEditModal from "./CompanyEditModal";



const CompanyTotalDetails = ({ organization }) => {
  const companyName = organization?.content?.en?.title;
  const description = organization?.content?.en?.content;
  const logo = organization?.logo?.url;
  const coverImage = organization?.coverImage?.url;
  const contactEmail = organization?.contactEmail;
  const createdAt = organization?.createdAt;
  const industry = organization?.businessInfo?.industry;
  const employeeCount = organization?.businessInfo?.employeeCount;
  const headquarter = organization?.headquarter;
  const website = organization?.website;
  const { session } = useSelector((state) => state.authProvider);
  const navigate = useNavigate();
  const [isStartChatOpen, setIsStartChatOpen] = React.useState(false);
  const [isStartingChat, setIsStartingChat] = React.useState(false);
  const [editCompanyDetails, setEditCompanyDetails] = useState(false)

  const companyMenu = [
    {
      name: "Visit website",
      icon: "fa-regular fa-arrow-up-right-from-square",
      //   link: "/edit-company",
    },
    {
      name: "Send in a message",
      icon: "fa-solid fa-paper-plane",
      //   click: () => console.log("Share clicked"),
    },
  ];
  const isOwnOrganization =
    session?.user?.organization &&
    organization?._id &&
    session.user.organization === organization._id;
  const tabs = useMemo(
    () => [
      {
        label: "Home",
        key: "home",
        content: <CompanyHomeTab organization={organization} />,
      },
      {
        label: "About",
        key: "about",
        content: <CompanyAboutTab slug={organization?.slug} />,
      },
      {
        label: "Jobs",
        key: "jobs",
        content: <CompanyJobsTab slug={organization?.slug} />,
      },
      // {
      //   label: "People",
      //   key: "people ",
      //   content: <CompanyPeopleTab />,
      // },
    ],
    [organization],
  );

  const { selectedIndex, handleTabChange, validTab } = useTabQuery(tabs);

  if (!validTab) {
    return <NotFoundPage link="/admin/payments?tab=subscriptions" />;
  }

  const currentUserId = session?.user?._id;

  const handleStartChat = async (content) => {
    if (!currentUserId) return;

    const trimmed = String(content || "").trim();
    if (!trimmed) {
      toast.warning("Please type a message.");
      return;
    }

    const payload = {
      recipientType: "company",
      // organization: organization?._id,
      inboxType: "company",
      type: "chat",
      customerId: organization?._id,
      createdBy: currentUserId,
      message: {
        // user: currentUserId,
        name: session?.user?.firstName || "User",
        content: trimmed,
      },
    };

    setIsStartingChat(true);
    try {
      const res = await CreateChat(payload);

      const chatId = res?.data?.communicationGroupId; // 👈 important

      // ✅ Redirect with chatId
      if (chatId) {
        setIsStartChatOpen(false);
        navigate(`/messages?chatId=${chatId}&companyId=${organization?._id}`);
      }
    } catch (err) {
      toast.error(
        err?.data?.message || err?.message || "Failed to start chat.",
      );
    } finally {
      setIsStartingChat(false);
    }
  };
  const normalizedWebsite = website?.startsWith("http")
    ? website
    : `https://${website}`;
  return (
    <>
      <div className="bg-white rounded-t-xl shadow-sm overflow-hidden">
        <div className="relative">
          <img
            src={coverImage}
            alt="banner"
            className="w-full h-40 object-cover"
          />

          <div className="absolute -bottom-12 left-8">
            <div className="w-28 h-28 bg-white border-4 border-white rounded">
              <img
                src={logo}
                alt={companyName}
                className="w-full h-full object-contain rounded shadow-sm"
              />
              {/* <Indentification
                image={logo}
                alt={companyName}
                size="xl3"
                className="!shadow-[0_0_8px_rgba(0,0,0,0.12)]"
                fill={false}
              /> */}
            </div>
          </div>
        </div>

        <div className="pt-16 px-3 md:px-6 pb-6 border border-b-0">
          <div className="flex items-center gap-2">
            <h2 className="text-lg font-semibold text-gray-900 tracking-tight">
              {" "}
              {companyName}
            </h2>
          </div>

          <p className="text-sm text-gray-600 font-medium leading-relaxed">
            {description}
          </p>
          <p className="text-gray-500 text-sm mt-1">
            Founded {new Date(createdAt).getFullYear()}
          </p>
          <p className="text-sm text-gray-500 font-sans">
            {[
              industry,
              headquarter,
              employeeCount && `${employeeCount} employees`,
            ]
              .filter(Boolean)
              .join(" · ")}
          </p>

          {/* <div className="flex items-center gap-2 mt-3 text-sm text-gray-600">
          <img
            src="https://randomuser.me/api/portraits/men/32.jpg"
            alt=""
            className="w-6 h-6 rounded-full"
          />
          <span>Purnendu & 1 other connection follow this page</span>
        </div> */}

          <div className="flex items-center gap-3 mt-5">
            {website && (
              <Button
                buttonLabel="Visit Website"
                buttonHasLink
                buttonLink={normalizedWebsite}
                target="_blank"
                buttonIcon={"fa-regular fa-arrow-up-right-from-square"}
                buttonIconPosition="left"
                buttonClasses="bg-white text-xs text-palatte border border-palatte px-4 h-9 rounded-full hover:bg-palatte hover:text-white"
                buttonLabelClasses={"text-xs md:text-sm whitespace-nowrap"}
              />
            )}

            {isOwnOrganization ? (
              <Button
                buttonLabel="Edit Company"
                // buttonFunction={() =>
                //   navigate(`/manage-company?id=${organization?.slug}`)
                // }
                buttonFunction={() => { setEditCompanyDetails(true) }}
                buttonIcon={"fa-solid fa-pen"}
                buttonIconPosition="left"
                buttonClasses="bg-palatte text-xs text-white px-4 h-9 rounded-full hover:opacity-90"
                 buttonLabelClasses={"text-xs md:text-sm whitespace-nowrap"}
              />
            ) : (
              <Button
                buttonLabel="Message"
                buttonFunction={() => setIsStartChatOpen(true)}
                buttonIcon={"fa-solid fa-paper-plane"}
                buttonIconPosition="left"
                buttonClasses="bg-white text-xs text-palatte border border-palatte px-4 h-9 rounded-full hover:bg-palatte hover:text-white"
                 buttonLabelClasses={"text-xs md:text-sm whitespace-nowrap"}
              />
            )}
          </div>
        </div>
      </div>
      <div className="">
        <Tabs
          items={tabs}
          selectedIndex={selectedIndex}
          setSelectedIndex={handleTabChange}
          tabsClass="gap-10 border-t border-gray-200 pt-2 px-6  w-full bg-white rounded-b-xl before:border-b-0 border"
          underLineClass="h-[1.5px] -left-5 -right-5 w-auto"

        //   tabcontentBody="mt-0"
        />
      </div>

      <StartChatModal
        isOpen={isStartChatOpen}
        onClose={() => setIsStartChatOpen(false)}
        title="Message"
        subtitle={`Send a message to ${companyName || "this company"}`}
        isSending={isStartingChat}
        onSend={handleStartChat}
      />
      <CompanyEditModal
        isOpen={editCompanyDetails}
        onClose={() => setEditCompanyDetails(false)}
        organization={organization?.slug}
      />
    </>
  );
};

export default CompanyTotalDetails;
